'use client';
import React, { useState, useEffect, useRef } from 'react';
import { useViewport } from '../../../hooks';
import styles from './PdfViewer.module.scss';
import { classNames } from '../../../utils/classNames';

// Constants for CDN URLs
interface PdfViewerProps {
  pdfUrl: string;
}

export const PdfViewer: React.FC<PdfViewerProps> = ({ pdfUrl }) => {
  const [safePdfUrl, setSafePdfUrl] = useState<string>('');
  const [isLoaded, setIsLoaded] = useState(false);
  const pdfIframeRef = useRef<HTMLIFrameElement>(null);
  const { isMobile } = useViewport();

  useEffect(() => {
    if (!pdfUrl) {
      // If no PDF URL, could redirect or show error message
      console.warn('No PDF URL provided to PdfViewer component');
      return;
    }

    if (isMobile) {
      // For mobile devices, redirect to the PDF URL without adding to history
      window.location.replace(pdfUrl);
    } else {
      // For desktop, set the URL for iframe display
      setSafePdfUrl(pdfUrl);
    }
  }, [pdfUrl, isMobile]);

  const handlePdfLoad = () => {
    setIsLoaded(true);
    if (pdfIframeRef.current) {
      pdfIframeRef.current.style.display = 'block';
    }
  };

  // If mobile, don't render the iframe (will redirect instead)
  if (isMobile) {
    return null;
  }

  // If no PDF URL, don't render anything
  if (!pdfUrl) {
    return null;
  }

  return (
    <>
      {safePdfUrl && (
        <iframe
          ref={pdfIframeRef}
          src={safePdfUrl}
          className={classNames(styles['pdf__viewer'], isLoaded && styles['pdf__viewer--loaded'])}
          onLoad={handlePdfLoad}
          title="PDF Viewer"
        />
      )}
    </>
  );
};
